export const styles = {
  // root: (theme, isMobileFullsize, topNavigation) => ({
  root: (theme, isMobileFullsize, negativeMargin) => ({
    width: {
      xs: isMobileFullsize ? 'calc(100% + 16px * 2)' : '100%',
      xl: '100%',
    },
    margin: {
      xs: isMobileFullsize ? '0 -16px' : 0,
      // md: topNavigation ? "-100px 0 0" : 0,
      md: negativeMargin || 0,
    },
  }),
  buttonSlideNext: (_, isFinite, isEnd) => ({
    opacity: isEnd && isFinite ? 0.3 : 1,
  }),
  buttonSlidePrev: (_, isFinite, isBeginning) => ({
    transform: 'rotate(180deg)',
    opacity: isBeginning && isFinite ? 0.3 : 1,
  }),
  onSideButtonSlideNext: (_, isFinite, isEnd) => ({
    position: 'absolute',
    top: '50%',
    right: -60,
    opacity: isEnd && isFinite ? 0.3 : 1,
  }),
  onSideButtonSlidePrev: (_, isFinite, isBeginning) => ({
    position: 'absolute',
    transform: 'rotate(180deg)',
    opacity: isBeginning && isFinite ? 0.3 : 1,
    top: '50%',
    left: -60,
  }),
  buttonBlock: (_, navigatePosition) => ({
    mt: navigatePosition === 'top' ? 0 : 5,
    mb: navigatePosition === 'top' ? 5 : 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  }),
  swiperWrapperNav: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
  },
  swiperWrapper: (isMobileFullsize, zIndexActive) => ({
    width: '100%',
    '& > .swiper-initialized': {
      m: isMobileFullsize ? -1 : 0,
      padding: {
        xs: isMobileFullsize ? '8px 16px' : 0,
        xl: isMobileFullsize ? 1 : 0,
      },
    },
    '& .swiper-slide': {
      height: 'auto',
    },
    ...(zIndexActive
      ? {
          '& .swiper-slide-active': {
            zIndex: 1,
          },
        }
      : {}),
  }),
};
